import React, { useState, useEffect } from "react";
import { Card, Button, Table } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./styles/styles.css";
import { styles } from "./styles/styles";
import {
  formatCurrency,
  formatterUSD,
} from "../../commons/functions/generalFunctions";
import { removeProduct, handleOneProduct } from "../../redux/actions/cart";
const ItemCart = (props) => {
  const {
    id,
    name,
    code,
    price,
    image,
    quantity,
    customText,
    letter,
    showName,
    removeProduct,
    handleOneProduct,
    cart,
    currencySelect,
  } = props;
  const [currencyValue, SetCurrencyValue] = useState(0);
  const [viewDetails, setViewDetails] = useState(false);
  useEffect(() => {
    if (currencySelect.currency.currency === "USD") {
      SetCurrencyValue(currencySelect.currency.currencyLayer);
    } else {
      SetCurrencyValue(0);
    }
  }, [currencySelect]);

  return (
    <>
      <div className="container-fluid">
        <div className="row " style={styles.divRow}>
          <div
            className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12 p-12"
            style={styles.divColumns}
          >
            <div className="text-center">
              <Link to={`/product/${props.id}`}>
                <Card
                  style={{
                    backgroundImage: `url(${image})`,
                    backgroundSize: "cover",
                    objectFit: "cover",
                    backgroundPosition: "center",
                    height: 70,
                    width: 70,
                  }}
                />
              </Link>
            </div>
            <div className="div-buttons-sbc" style={styles.divButtons}>
              <div>
                <h6 style={styles.divH6}>
                  {code || name}
                  <span className="date">
                    {currencySelect.loading
                      ? "Cargando..."
                      : currencyValue === 0
                      ? formatCurrency(Math.ceil(price))
                      : formatterUSD.format(
                          Math.ceil(price / currencyValue.data.value) - 0.01
                        )}
                  </span>
                </h6>
              </div>
              <div>
                <Button.Group>
                  <Button
                    disabled={quantity === 1 ? true : false}
                    onClick={() => handleOneProduct(cart.cart, id, -1)}
                  >
                    -
                  </Button>
                  <Button.Or text={quantity} />
                  <Button onClick={() => handleOneProduct(cart.cart, id, 1)}>
                    +
                  </Button>
                </Button.Group>
              </div>
            </div>
            <div className="button-sbc" onClick={() => removeProduct(id)}>
              <span className="span-sbc ">REMOVER</span>
            </div>
          </div>
          {(customText || letter || showName === "true") && (
            <div
              className="button-sbc"
              onClick={() => setViewDetails(!viewDetails)}
            >
              <span className="span-sbc ">DETALLES</span>
            </div>
          )}
          {viewDetails && (
            <div style={styles.detailsView}>
              {(customText || letter) && (
                <Table definition style={{ marginTop: 8 }}>
                  <Table.Body>
                    {customText && (
                      <Table.Row>
                        <Table.Cell width={2}>
                          <span style={styles.labelFrase}>Frase: </span>
                        </Table.Cell>
                        <Table.Cell width={16}>
                          <p style={styles.labelFrase}>{customText}</p>
                        </Table.Cell>
                      </Table.Row>
                    )}
                    {letter && (
                      <Table.Row>
                        <Table.Cell width={4} style={{ paddingRight: 0 }}>
                          <span style={styles.labelFrase}>Dedicatoria:</span>
                        </Table.Cell>
                        <Table.Cell>
                          <p style={styles.labelFrase}>{letter}</p>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </Table.Body>
                </Table>
              )}
              {showName && (
                <div style={styles.showName}>
                  <span style={{ color: "red" }}>*</span>
                  <p style={styles.labelFrase}>{`Su nombre ${
                    showName === "true" ? "" : "no"
                  } se mostrará en la dedicatoria.`}</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    currencySelect: state.currencySelect,
  };
};
export default connect(mapStateToProps, { removeProduct, handleOneProduct })(
  ItemCart
);
